import Base from './Base';


class Catalog extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'catalogs';
    }

    getAll( ) {
        return  fetch(this.getUrlEndpoint("retrieve/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getProducts( ) {
        return  fetch(this.getUrlEndpoint("products/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    saveCatalogClient( images, email ) {
        var formData = new FormData();
        let aux ='';
        images.forEach(( image, index )=> {
            if(image !== null){
                formData.append(aux.concat("imagen",index) ,image)
            }
        });
        formData.append("email", email)
        return  fetch(this.getUrlEndpoint("save-inventory/"),{
            method: 'POST',
            headers: this.fileHeaders,
            body: formData
        }).then( response => response.json() )
    }
    
}

export default Catalog;